// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_519fabd9","separator":"rdg_ba87d109"};